import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app/App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "../src/context/AuthContext";
import { LoadingProvider } from "../src/context/LoadingContext";
import { StaticDataProvider } from "../src/context/StaticDataContext";
import { AccessProvider } from "../src/context/AccessContext";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import "dayjs/locale/en-gb";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(rootElement as HTMLElement);

root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
      <LoadingProvider>
        <BrowserRouter>
          <AuthProvider>
            <AccessProvider>
              <StaticDataProvider>
                <App />
              </StaticDataProvider>
            </AccessProvider>
          </AuthProvider>
        </BrowserRouter>
      </LoadingProvider>
    </LocalizationProvider>
  </React.StrictMode>,
);

// Optional: measure performance
reportWebVitals();
